import React from 'react';
import { PropTypes } from 'prop-types';
import { useScreenSmDown, useScreenMinMd } from '@hooks/useResponsive';

const getIconDesktop = isActive => {
    const fill = isActive ? '#246EFF' : '#D3D0D5';
    const stroke = isActive ? '#fff' : '#000';
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
            <g fill="none" fillRule="evenodd">
                <circle cx="19.692" cy="19.692" r="19.692" fill={fill} />
                <g stroke={stroke} strokeWidth="1.64" transform="translate(12 8)">
                    <polygon strokeLinecap="square" points="0 9.123 15.629 9.123 15.629 20.071 0 20.071" />
                    <circle cx="7.792" cy="14.575" r="2.125" strokeLinecap="square" />
                    <path d="M12.1491206,9.12333333 L12.1491206,4.56166667 C12.1722399,2.06767329 10.3077559,0.0255683175 7.98422486,1.33869315e-13 L7.89922698,1.33869315e-13 C5.57568881,-0.0248153102 3.67315415,1.97644756 3.64933333,4.47043333 L3.64933333,9.12333333" />
                </g>
            </g>
        </svg>
    );
};

const getIconMobile = isActive => {
    const stroke = isActive ? '#246EFF' : '#1A1A1A';
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="16" viewBox="0 0 13 16">
            <g fill="none" fillRule="evenodd" stroke={stroke} transform="translate(1 1)">
                <polygon strokeLinecap="square" points="0 6.44 11.032 6.44 11.032 14.168 0 14.168" />
                <circle cx="5.5" cy="10.288" r="1.5" strokeLinecap="square" />
                <path d="M8.57584986,6.44 L8.57584986,3.22 C8.59216935,1.45953409 7.27606302,0.0180482241 5.63592343,9.44959714e-14 L5.57592493,9.44959714e-14 C3.93578034,-0.0175166896 2.59281469,1.39513946 2.576,3.1556 L2.576,6.44" />
            </g>
        </svg>
    );
};

const MenuPassword = ({ isActive = false }) => {
    const isScreenSmDown = useScreenSmDown();
    const isScreenMinMd = useScreenMinMd();

    return (
        <>
            {isScreenSmDown && getIconMobile(isActive)}
            {isScreenMinMd && getIconDesktop(isActive)}
        </>
    );
};

MenuPassword.propTypes = {
    isActive: PropTypes.bool,
};

export default MenuPassword;
